

export  const nonmemdefaultValues = {
    company_number: '',
    company_name: '',
    registered_address: [],
    trading_address: [],
};

export default nonmemdefaultValues;
